import { type RefObject, useEffect } from "react";

const VIRTUAL_SCROLLER_SELECTOR = ".MuiDataGrid-virtualScroller";

export const useDataGridHeaderScrollSync = (
  dataGridRootRef: RefObject<HTMLDivElement | null>,
  headerRootRef: RefObject<HTMLDivElement | null>,
  isDisabled = false
) => {
  useEffect(() => {
    if (isDisabled) return;

    const dataGridRoot = dataGridRootRef.current;
    const headerRoot = headerRootRef.current;

    if (!dataGridRoot || !headerRoot) return;

    const scroller = dataGridRoot.querySelector<HTMLElement>(
      VIRTUAL_SCROLLER_SELECTOR
    );

    if (!scroller) return;

    const sync = () => {
      if (headerRoot.scrollLeft !== scroller.scrollLeft) {
        headerRoot.scrollLeft = scroller.scrollLeft;
      }
    };

    sync();
    scroller.addEventListener("scroll", sync, { passive: true });

    return () => {
      scroller.removeEventListener("scroll", sync);
    };
  }, [dataGridRootRef, headerRootRef, isDisabled]);
};
